/* src/modules/tutors/reducers.js */

import { combineReducers } from 'redux';
import { keyBy } from 'lodash';

import {
  fetchTutorsTypes,
  fetchTutorTypes,
  CLEAR_SELECTED_TUTOR,
} from './action_types';

import { ON_ERROR } from '../app_state/action_types';

import { makeRequestReducer } from '../../config/client';

const main = makeRequestReducer({
  types: fetchTutorsTypes,
  name: 'tutors',
  mutate: (state, res) => keyBy(res, '_id'),
  append: [
    (state, action) => {
      switch (action.type) {
        case ON_ERROR:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
  ],
});

const single = makeRequestReducer({
  types: fetchTutorTypes,
  name: 'tutorByID',
  append: [
    (state, action) => {
      switch (action.type) {
        case CLEAR_SELECTED_TUTOR:
        case ON_ERROR:
          return { ...state, data: {} };
        default:
          return state;
      }
    },
  ],
});

export default combineReducers({
  main,
  single,
});



// WEBPACK FOOTER //
// ./src/modules/tutors/reducers.js